import { deepEqual } from '@/js/services/Utils'
import { BuyRequest } from '@/js/services/types/order'

function compareMeta(meta1: BuyRequest['metadata'], meta2: BuyRequest['metadata']): boolean {
  return deepEqual(meta1?.giftcard, meta2?.giftcard) && meta1?.recipeId === meta2?.recipeId && deepEqual(meta1?.plateOpts, meta2?.plateOpts) && meta1?.recipe === meta2?.recipe
}

/**
 * Finds a duplicate item in a list
 * @param {BuyRequest} item
 * @param {BuyRequest[]} items
 */
export function findDuplicateItem(item: BuyRequest, items: BuyRequest[]): BuyRequest | undefined {
  if (!items || !item) {
    return undefined
  }
  const { productId, metadata = {}, options = {}, children = [] } = item

  const childrenWithQty = children.filter(c => c.qty > 0 && !c.metadata?.freeBundleOptionId)

  return items.find(existing => existing.productId === productId
    && compareMeta(existing?.metadata || {}, metadata)
    && deepEqual(existing.options || {}, options)
    && childrenWithQty.length === (existing.children || []).filter(c => !c.metadata?.freeBundleOptionId).length
    && childrenWithQty.every(child => findDuplicateItem(child, existing.children || [])))
}
